<template>
    <div class="content-wrapper flex flex-direction flex-sub padding-sm">
        <div class="bg-white padding flex-sub">
            <div class="search-container">
                <el-row style="width: 100%">
<!--                    <el-col :span="6" class="search-item flex align-center">-->
<!--                        <el-date-picker-->
<!--                            v-model="timeStr"-->
<!--                            placeholder="选择日期"-->
<!--                            type="date"-->
<!--                            value-format="yyyy-MM-dd 00:00:00">-->
<!--                        </el-date-picker>-->
<!--                        <el-button-->
<!--                            class="btn mid margin-left-xs"-->
<!--                            type="primary"-->
<!--                            @click="search">搜索-->
<!--                        </el-button>-->
<!--                    </el-col>-->
                    <el-col :span="24">
                        <div class="flex align-center justify-end padding-bottom-sm">
                            <div class="flex align-center">
<!--                                <el-button-->
<!--                                    class="btn mid"-->
<!--                                    type="primary"-->
<!--                                    @click="exportData">导出-->
<!--                                </el-button>-->
                                <el-button
                                    class="btn mid"
                                    type="primary"
                                    @click="addItem(false)" v-permission="'expenditure'">添加
                                </el-button>
                                <el-button
                                    class="btn mid"
                                    type="primary"
                                    @click="toPage(`/digitize`)">预览
                                </el-button>
                            </div>
                        </div>
                    </el-col>
                </el-row>
            </div>
            <div class="page-list flex flex-direction">
                <el-table
                    v-loading="loading"
                    :data="lists"
                    :row-class-name="tableRowClassName"
                    border
                    header-row-class-name="table-header"
                    style="width: 100%">
                    <el-table-column
                        label="日期"
                        prop="funding_time"
                        width="120">
                    </el-table-column>
                    <el-table-column
                        label="经费说明"
                        prop="name">
                    </el-table-column>
                    <el-table-column
                        label="发生金额"
                        prop="money"
                        width="120">
                        <template slot-scope="scope">
                            <div class="table-item" :class="scope.row.type === 1 ? 'text-green' : 'text-red'">
                                {{scope.row.type === 1 ? '+' : '-'}}{{scope.row.amount}}
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column
                        label="结存"
                        prop="total_amount"
                        width="120">
                    </el-table-column>
                    <el-table-column
                        label="操作"
                        width="220">
                        <template slot-scope="scope">
                            <div class="table-item">
                                <el-button  type="text" @click="showItem(scope.row)">查看</el-button>
                                <el-button  type="text" @click="addItem(scope.row)" v-permission="'expenditure'">编辑</el-button>
                                <el-button type="text" @click="delItem(scope.row)" v-permission="'expenditure'">删除</el-button>
                            </div>
                        </template>
                    </el-table-column>
                </el-table>
                <el-pagination
                    :current-page.sync="page"
                    :page-size="limit"
                    :total="total"
                    background
                    class="page-all margin-top self-end"
                    layout="prev, pager, next,total"
                    @current-change="getList">
                </el-pagination>
            </div>
        </div>
        <add-expenditure-dialog :dialog-visible="addExpenditureDialog" :eid="cur_eid" @watchState="watchState"></add-expenditure-dialog>
        <expenditure-detail-dialog :dialog-visible="expenditureDetailDialog" :eid="cur_eid" @watchState="watchState"></expenditure-detail-dialog>
    </div>
</template>

<script>
import {
    confirm, TOAST, toast, zhDate
} from "@/utils/utils";
import {delFunding, fundingList} from "@/api";
import AddExpenditureDialog from "@/views/web/manager/page/expenditure/components/AddExpenditureDialog";
import ExpenditureDetailDialog from "@/views/web/manager/page/expenditure/components/ExpenditureDetailDialog";

export default {
    name: "expenditure-list",
    components: {ExpenditureDetailDialog, AddExpenditureDialog},
    data() {
        return {
            timeStr:'',
            lists: [],
            page: 1,
            limit: 15,
            total: 0,
            loading: false,
            cur_eid :0,
            addExpenditureDialog: false,
            expenditureDetailDialog: false,
        };
    },
    props: {},
    computed: {
        user() {
            return this.$store.state.user
        },
    },
    activated() {
        this.init()
    },
    methods: {
        init() {
            this.$emit('setIndex', [7])
            this.getList()
        },
        tableRowClassName({rowIndex}) {
            if (rowIndex % 2 === 0) {
                return 'white'
            } else {
                return 'redlight'
            }
        },
        async getList() {
            this.loading = true
            let _data = await fundingList(this.page,this.limit)
            _data.data.data.map(item=>{
                item.funding_time = zhDate(item.funding_time)
            })
            this.lists = _data.data.data
            this.total = _data.data.total
            this.loading = false
        },
        search() {
            this.page = 1
            this.getList()
        },
        addItem(data) {
            if (data) this.cur_eid = data.id
            this.addExpenditureDialog = true
        },
        showItem(data) {
            if (data) this.cur_eid = data.id
            this.expenditureDetailDialog = true
        },
        watchState(data){
            if (data) this.getList()
            this.cur_eid = 0
            this.addExpenditureDialog = false
            this.expenditureDetailDialog = false
        },
        async exportData() {

        },
        delItem(item) {
            confirm(`删除`, `你确定删除<b>${item.name}</b>的党建经费信息吗？`, () => {
                this.submitDel(item.id)
            }, '确认', true)
        },
        async submitDel(id) {
            let _data = await delFunding(id)
            if (_data.status === 200) {
                toast('删除成功', TOAST.success)
                this.getList()
            } else {
                toast(_data.info, TOAST.error)
            }
        },
        toPage(path) {
            this.$router.push(path)
        },
    },
    filters: {
        zhDate(val) {
            return zhDate(val, 2)
        },
    },
}
</script>

<style lang="scss" scoped>
.content-wrapper {

    .search-item {
        margin-bottom: 20px;
    }


}
</style>